import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-check-all',
  standalone: true,
  imports: [Button],
  templateUrl: './check-all.component.html',
  styleUrl: './check-all.component.scss',
})
export class CheckAllComponent {
  @Input() allLabel = 'alle auswählen';
  @Input() noneLabel = 'alle abwählen';
  @Input() items: any[] = []; // The list of all item keys
  @Input() selection: any[] = []; // The current selection state
  @Output() selectionChange = new EventEmitter<string[]>(); // Emits updated selection

  /**
   * Toggles the selection between all items selected or none selected.
   */
  toggleSelection(): void {
    if (this.isAllSelected()) {
      // Deselect all if already fully selected
      this.selection = [];
    } else {
      // Select all items
      this.selection = [...this.items];
    }
    this.selectionChange.emit(this.selection);
  }

  /**
   * Checks if all items are currently selected.
   * @returns True if all items are selected, otherwise false.
   */
  isAllSelected(): boolean {
    return this.items.length === this.selection.length;
  }
}
